import httpService from './http.service';

const getParkingTemplate = () => httpService
    .get('/parkingtemplate')
    .then(({data}) => data)
    .catch((err) => Promise.reject(err.response));


// const getAllSubjectsParam = (filter, page, size) => httpService
//     .get(`/subjects/param${getQuery(filter, page, size)}`)
//     .then(({data}) => data)
//     .catch((err) => Promise.reject(err.response));


// const createSubject = (subject) => httpService
//     .post(`/subject`, subject)
//     .then(({data}) => data)
//     .catch((err) => {
//         throw err;
//     });

// const updateSubject = (subject) => httpService
//     .put(`/subject`, subject)
//     .then(({data}) => data)
//     .catch((err) => Promise.reject(err));


export default {
    getParkingTemplate,
};
